import { t } from "@/i18n";

/**
 * Returns a human-readable relative time string.
 * Falls back to ISO date for dates older than 30 days.
 */
export function timeAgo(dateStr: string): string {
  const now = Date.now();
  const then = new Date(dateStr).getTime();
  const diff = now - then;

  if (diff < 0 || Number.isNaN(diff)) return dateStr;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) return t("time.justNow");
  if (minutes < 60) return t("time.minutesAgo").replace("{n}", String(minutes));
  if (hours < 24) return t("time.hoursAgo").replace("{n}", String(hours));
  if (days <= 30) return t("time.daysAgo").replace("{n}", String(days));

  return new Date(dateStr).toLocaleDateString();
}
